import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, finalize, share } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { BrowserFingerprintService } from './browser-fingerprint.service';

/** POST /auth/web/refresh via HttpBackend (no interceptor / no 401 loop). */
@Injectable({ providedIn: 'root' })
export class SessionRefreshService {
  private readonly rawHttp: HttpClient;
  private inFlight: Observable<void> | null = null;

  constructor(
    backend: HttpBackend,
    private apiService: ApiService,
    private fingerprintService: BrowserFingerprintService,
    private router: Router,
  ) {
    this.rawHttp = new HttpClient(backend);
  }

  private buildRefreshHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const fp = this.fingerprintService.getCached();
    if (fp) {
      headers = headers.set('X-Device-Fingerprint', fp);
    }
    headers = headers.set('Accept-Language', localStorage.getItem('language') || 'en');
    const removeScreenId = localStorage.getItem('removeScreenId') === 'true';
    const screenId = localStorage.getItem('screenId');
    if (this.router.url.includes('/digital-signature?')) {
      if (screenId) {
        headers = headers.set('screen_id', screenId);
      }
    } else if (!removeScreenId && screenId) {
      headers = headers.set('screen_id', screenId);
    }
    localStorage.removeItem('removeScreenId');
    return headers;
  }

  refreshOnce(): Observable<void> {
    if (!this.inFlight) {
      const url = this.apiService.getAuthRefreshUrl();
      const headers = this.buildRefreshHeaders();
      this.inFlight = this.rawHttp
        .post(url, {}, { withCredentials: true, observe: 'body', responseType: 'json', headers })
        .pipe(
          map(() => undefined),
          finalize(() => {
            this.inFlight = null;
          }),
          share(),
        );
    }
    return this.inFlight;
  }
}
